import { render, staticRenderFns } from "./LinkedItem.vue?vue&type=template&id=252c3c3c&scoped=true&"
import script from "./LinkedItem.vue?vue&type=script&lang=js&"
export * from "./LinkedItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252c3c3c",
  null
  
)

export default component.exports